/*
 * File per la definizione dei Service Angular, ovvero oggetti che espongono funzionalita' condivise tra diversi Controller:
 * https://code.angularjs.org/1.5.8/docs/guide/services
 * 
 * DISCLAIMER:
 * 
 * La promise come dice la parola stessa e' una 'promessa', associata a un'operazione asincrona la cui terminazione non e' nota a priori. 
 * Dal punto di vista applicativo la promise e' un oggetto contenitore vuoto sul quale si possono invocare due metodi: then() e when().
 * Il metodo then() prende come argomento una funzione (callback) che viene eseguita solo dopo che la promise e' stata 'risolta'. 
 * Nel caso di una chiamata AJAX, la promise e' 'risolta' una volta che e' stata ricevuta la risposta dal server.
 * 
 * AngularJS utilizza l'oggetto $q per gestire le promise. 
 * L'oggetto $q offre il metodo defer().
 * L'invocazione di questo metodo 'ritorna' un oggetto defer il cui scopo e' quello di esporre e gestire il ciclo di vita di una promise.
 * Con ciclo di vita si intende la possibiltia' di poter 'riempire' la promise con i dati reali al termine di una chiamata asincrona. 
 * 
 * https://code.angularjs.org/1.5.8/docs/api/ng/service/$q
 */
define([
	'angular'
],
function(angular) {

	var ajaxServices = angular.module('ajaxServices', []);

	ajaxServices.service('AjaxService', ['$q', '$http', '$log', AjaxService]);
	ajaxServices.service('Resolver',['$q', Resolver]);

    /*
	 * Service che offre un punto di accesso unico per definire chiamate AJAX verso il back-end
     */
	function AjaxService($q, $http, $log) {

		var _promises = {};

        var _genericCallback = function(key, data) {
            _promises[key] = data;
        };

        /*
         * Funzione di utilita' che permette di ottenere i dati dal server solo quando esplicitamente richiesto o necessario
         */
        this.promisesGetter = function(URL, data, params, key, refresh) {
            if (!refresh && _promises[key] !== undefined) {
            	/*
            	 * Se il parametro refresh e' 'false' o il dato e' gia' presente, viene semplicemente restituito al Controller
            	 */
                return $q.when(_promises[key]); 
            } else {
            	/*
            	 * Se il parametro refresh e' 'true' o il dato non e' presente, viene eseguita la chiamata AJAX
                 */
                return this.ajaxRequest("GET", URL, data, params, _genericCallback, key);
            }
        };

        /*
         * Funzione per effettuare le chiamate AJAX.
         * Questa funzione ritorna sempre un oggetto di tipo promise.
         * Una volta che la chiamata AJAX asincrona e' terminata, la promise:
         * - in caso di successo, viene 'risolta' e riempita con i dati 'tornati' dal server (deferred.resolve(response.data));
         * - in caso di errore, viene 'rifiutata' e riempita con la causa del fallimento (deferred.reject(error)).
         */
        this.ajaxRequest = function(method, URL, data, params, callback, key) {
            var deferred = $q.defer();
            
            /*
             * Se non ci sono parametri da passare come query string, viene inizializzato l'oggetto vuoto
             */
            params = params ? params : {};

            //se tra i parametri ? presente il pincode lo passo nell'header e non nella url
            var pincode = "";
            if (params.pincode) {
                pincode = params.pincode;
                delete params.pincode;
            }
            /*
             * Viene aggiunto ai parametri il timestamp per evitare la cache
             */
            params.v = new Date().getTime();
            
            $http({
            	method: method,
            	url: URL,
            	data: data,
            	params: params,
            	/*
            	 * Headers di sicurezza
            	 */
            	headers: {
					"X-Content-Type-Options": "nosniff",
					"X-XSS-Protection": "1; mode=block",
					"X-Frame-Options": "deny",
                    "Strict-Transport-Security": "max-age=16070400; includeSubDomains",
                    "pincode": pincode
				}
            }).then(function(response) {
            	deferred.resolve(response.data);
                if (callback) {
                	callback(key, response.data);
                }
            },function(error) {
                deferred.reject(error);
            });
            return deferred.promise;
        };
	}

	/*
	 * Service che prende come input un array di promise e ne restituisce i risultati
	 */
	function Resolver($q) {
        return function(promises) {
            return $q.all(promises);
        };
    }

	return ajaxServices;	
});


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/resources/js/app/services/ajax-services.js
// module id = 42
// module chunks = 1